export function eventSlug(value: string): string {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}

// Names and codes, with or without separators, must identify exactly one available event.
export function resolveEvent<T>(items: T[], reference: string, id: (item: T) => number, names: (item: T) => string[]): T | undefined {
  const privateLink = reference.match(/^([1-9]\d*)\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i);
  if (privateLink) return items.find(item => String(id(item)) === privateLink[1]);
  if (/^\d+$/.test(reference)) return undefined;
  const slug = eventSlug(reference);
  if (!slug) return undefined;
  const matches = items.filter(item => names(item).some(name => eventSlug(name).replace(/-/g, "") === slug.replace(/-/g, "")));
  return matches.length === 1 ? matches[0] : undefined;
}

export function eventFromPath(): string {
  if (/^\/\d+\/?$/.test(window.location.pathname)) return "";
  const privateLink = window.location.pathname.match(/^\/([1-9]\d*\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/?$/i);
  if (privateLink) return privateLink[1];
  if (/^\/\d+\//.test(window.location.pathname)) return "!invalid!";
  const match = window.location.pathname.match(/^\/([^/]+)\/?$/);
  if (!match || ["index.html", "login", "applications", "aplicaciones", "meetingplanner"].includes(match[1])) return "";
  try { return decodeURIComponent(match[1]); } catch { return "!invalid!"; }
}

// UUID links are validated by the server before selecting an event.
export function publicEventListPath(reference: string): string {
  return reference.includes("/") ? `/api/public/organize-events/${reference}` : "/api/public/events";
}
